import React, { useState, useContext } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { GlobalContext } from '../../GlobalReducer';
import { ReducerStateInterface } from '../../interfaces/core/ReducerStateInterface';
import { ClipboardCheck, Share } from 'react-bootstrap-icons';

interface ShareBasketModalProps {
    show: boolean;
    onHide: () => void;
}

interface SharedBasketData {
    name: string;
    items: Array<{
        id: number;
        quantity: number;
    }>;
}

const ShareBasketModal: React.FC<ShareBasketModalProps> = ({ show, onHide }) => {
    const [state] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [basketName, setBasketName] = useState('');
    const [copied, setCopied] = useState(false);

    const generateShareableLink = (): string => {
        if (!basketName.trim()) {
            return '';
        }

        const sharedData: SharedBasketData = {
            name: basketName.trim(),
            items: state.basket.map(item => ({
                id: item.product.id,
                quantity: item.quantity
            }))
        };

        const jsonString = JSON.stringify(sharedData);
        const base64Data = btoa(encodeURIComponent(jsonString));

        return `${window.location.origin}/shared-basket/${base64Data}`;
    };

    const shareableLink = generateShareableLink();

    const handleCopyToClipboard = async () => {
        if (shareableLink) {
            try {
                await navigator.clipboard.writeText(shareableLink);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
    };

    const handleClose = () => {
        setBasketName('');
        setCopied(false);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <Share className="me-2" />
                    Поделиться корзиной
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Название корзины</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Введите название корзины"
                            value={basketName}
                            onChange={(e) => setBasketName(e.target.value)}
                            autoFocus
                        />
                        <Form.Text className="text-muted">
                            Это название увидит получатель ссылки
                        </Form.Text>
                    </Form.Group>

                    {shareableLink && (
                        <Form.Group>
                            <Form.Label>Ссылка для отправки</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    value={shareableLink}
                                    readOnly
                                    onClick={(e) => (e.target as HTMLInputElement).select()}
                                />
                                <Button
                                    variant={copied ? 'success' : 'outline-secondary'}
                                    onClick={handleCopyToClipboard}
                                >
                                    {copied ? (
                                        <>
                                            <ClipboardCheck className="me-1" />
                                            Скопировано
                                        </>
                                    ) : (
                                        'Копировать'
                                    )}
                                </Button>
                            </InputGroup>
                            <Form.Text className="text-muted">
                                Корзина содержит {state.basket.length} товар(ов)
                            </Form.Text>
                        </Form.Group>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShareBasketModal;
